export default "__VITE_ASSET__CPpFFRNl__"